export default __webpack_public_path__ + "static/media/bitcoin-logo.82491fef.png";